import { cx } from '@otter-ai/den-components';
import { useQuery } from '@tanstack/react-query';
import { subscriptionQuery } from '@/query/subscriptionQueryCreator';
import type { ImportQuotas, UploadItem } from '../types/types';
import {
  hasBizCCTrialHitLimit,
  hasImportRestrictions,
  hasRemainingImportQuota,
  isOutOfMinutes,
} from '../utils/utils';
import { DisabledUploadButton, UploadButton } from './UploadButton';
import { UploadDropZone } from './UploadDropZone';
import { UploadQuotaExceeded } from './UploadQuotaExceeded';

type UploadAreaProps = {
  list: UploadItem[];
  isQuotaExceeded: boolean;
  quota: ImportQuotas;
};

export function UploadArea({ list, isQuotaExceeded, quota }: UploadAreaProps) {
  const hasFiles = list.length > 0;
  const { data: subscription } = useQuery(subscriptionQuery());
  const isUploadButtonDisabled =
    (hasImportRestrictions(quota) && !hasRemainingImportQuota(quota)) ||
    isOutOfMinutes(quota) ||
    hasBizCCTrialHitLimit({
      subscription: subscription,
    });

  return (
    <>
      <div
        className={cx(
          'flex flex-col items-center',
          hasFiles
            ? 'justify-end'
            : 'flex-1 justify-center border-t border-palette-gray-200',
        )}
      >
        {!hasFiles ? (
          <div
            data-testid="upload-drop-zone"
            className="flex w-[306px] flex-col items-center justify-center gap-0 md:gap-2 rounded-md border border-dashed border-palette-gray-400 py-6"
          >
            <UploadDropZone />
            {isUploadButtonDisabled ? (
              <DisabledUploadButton />
            ) : (
              <UploadButton />
            )}
          </div>
        ) : (
          <div className="my-4">
            {isUploadButtonDisabled ? (
              <DisabledUploadButton />
            ) : (
              <UploadButton />
            )}
          </div>
        )}
      </div>
      {isQuotaExceeded && <UploadQuotaExceeded />}
    </>
  );
}
